var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('header',{class:_vm.isFixedTop ? 'header-fixed-top' : '',style:({ height: _vm.headerHeight + 'px', background: _vm.headerBackgroundColor })},[_c('jsk-container',{style:({
        marginLeft: 'auto',
        marginRight: 'auto',
        maxWidth: _vm.width
      }),attrs:{"is-horizontal":"","has-bleed":_vm.hasBleed}},[_vm._t("default")],2)],1),(_vm.isFixedTop)?_c('div',{staticClass:"header-position",style:({ height: _vm.headerHeight + 'px' })}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }